export const anvPermissions = [
  {
    "Name": "Forms.View",
    "Roles": "FormManager"
  },
  {
    "Name": "Plants.View",
    "Roles": "1AnvAdmin, DataMaintainer"
  },
  {
    "Name": "Users.View",
    "Roles": "1AnvAdmin, DataMaintainer"
  },
  {
    "Name": "Providers.View",
    "Roles": "1AnvAdmin, DataMaintainer, ProviderManager"
  },
  {
    "Name": "Settings.View",
    "Roles": "1AnvAdmin"
  }
];
